import * as constantes from '../../constantes';
import React, { Component } from 'react';
import { Button , Confirm , Container , Dimmer , Grid , FormGroup , Header , Icon , Label , Loader , Message , Modal , Popup , Table , TextArea , Pagination } from 'semantic-ui-react'; 
import { Dropdown , Form , Input } from 'semantic-ui-react-form-validator';
import {Link} from 'react-router-dom'

import auth0Client from '../Auth/Auth'; 
const server = constantes.REST_API_PRIVATE;

const style = {
    h1: {
      marginTop: '1em',
    },
    h2: {
      margin: '1em 0em 1em',
    },
    h3: {
      marginTop: '2em',
      padding: '2em 0em',
    },
    last: {
      marginBottom: '300px',
    },
}

const _preguntaEmpty = {
    idPregunta : '',
	nombrePregunta : '',
	explicacionPregunta : '',
	datoExtra : '',
    posicion : 0,
	flujoSegunPregunta : '',
	rechazoInmediato : '',
	validarProyeccion : '',
	nota : '',
	saltar : '',
	respuesta : '',
	motivoAlternativaId : '',
	idEtapa : '',
	idTipoPregunta : '',
	tipoPantallaId : '',
    estado : 1 , 

    showDiasAsignados : false,
    showRechazoInmediato : false
}

const ListaFullTipoPreguntas = [];

export default class BaseDeConocimientos extends Component{

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            error: null,
            error2: null,
            errors: [],
            listaPreguntas: [],
            optionsTipoPantalla : null,
            optionsTipoPregunta : null,
            optionsEtapa:null,
            nuevaPregunta : _preguntaEmpty,
            showModalEdit:false,

            activePage:1,
            totalPages:0,
            totalRows:0,
            begin: 0,
            end: 5,

            confirmEliminarPreguntaOpen: false , 
            preguntaIdDelete : null ,
            dimmerEliminarPregunta :  false,

            txtBuscarPregunta : ''

        };

        this.onChange = this.onChange.bind(this);
        this._onChangeSelect = this._onChangeSelect.bind(this);
        this._onChangeSelectTipoPantalla = this._onChangeSelectTipoPantalla.bind(this);
        this._onChangeSelectTipoPregunta = this._onChangeSelectTipoPregunta.bind(this); 
        this._handlerChangeTextFunction =this._handlerChangeTextFunction.bind(this);
        this.handleChangeSearch = this.handleChangeSearch.bind(this);
        this.cargarListasModalPregunta = this.cargarListasModalPregunta.bind(this);
        this.editarPregunta = this.editarPregunta.bind(this);
        this.nuevaPregunta = this.nuevaPregunta.bind(this);
        this.eliminarPregunta = this.eliminarPregunta.bind(this);
        this.setShowModalEdit =this.setShowModalEdit.bind(this) ;

        this.guardarPregunta =this.guardarPregunta.bind(this) ;
        
        this.habilitarElementos =this.habilitarElementos.bind(this) ;

    }

    componentDidMount() {
        let METHODNAME = 'componentDidMount - ';
        console.log(METHODNAME + 'INI');

        auth0Client.isExpired();

        this.cargarListaDePreguntasPaginado( 1 );

        console.log(METHODNAME + 'FIN');
    }

    onChange (e, pageInfo) {
        let METHODNAME = 'onChange - ';
        console.log(METHODNAME + 'INI');

        console.log(METHODNAME + 'activePage = ' + pageInfo.activePage );

        this.setState({
            activePage : pageInfo.activePage
        });

        this.cargarListaDePreguntasPaginado( pageInfo.activePage );
        
    };

    habilitarElementos( lElementos ){
        let _optionsTipoPregunta = [];
        ListaFullTipoPreguntas.forEach(function(obj) {
            if( lElementos.includes( obj.key) ){
                _optionsTipoPregunta.push( { key: obj.key , text:  obj.text , value: obj.value } );
            }
        });
        this.setState({
            optionsTipoPregunta : _optionsTipoPregunta
        });
    }

    /**
     * Maneja el onchange de los SELECTs.
     * @param {*} e 
     * @param {*} param1 
     */
    _onChangeSelect(e, { name, value }) {
        let METHODNAME = '_onChangeSelect - ';
        console.log(METHODNAME + 'name = ' + name + '; value = ' + value + '; id = ' + e.target.id );
       
        this.setState(prevState => ({
            nuevaPregunta:{
              ...prevState.nuevaPregunta,
              [name]: value 
            }
        }));

    }

    /**
     * Maneja el onchange de los SELECTs.
     * @param {*} e 
     * @param {*} param1 
     */
     _onChangeSelectTipoPregunta(e, { name, value }) {
        let METHODNAME = '_onChangeSelectTipoPregunta - ';
        console.log(METHODNAME + 'name = ' + name + '; value = ' + value + '; id = ' + e.target.id );
       
        let _showRechazoInmediato = true;

        switch( value ){
            case 1 : 
                // SIMPLE
                _showRechazoInmediato = false;
                break;
            case 2 : 
                // 2	ANALISIS
                _showRechazoInmediato = false;
                break;
            case 3 : 
                //  3	RESOLUTORIA
                //rechazo inmediato permitido = 0  si TIPO_PANTALLA = 10 
                break;
            case 4 : 
                // 4	MOTIVO_RAC
                _showRechazoInmediato = false;
                break;
            case 5 : 
                // 5	RESPUESTA_MOTIVO
                //rechazo inmediato permitido = 2  si TIPO_PANTALLA = 10 
                break;
            case 6 : 
                //  6	CONSULTA
                _showRechazoInmediato = false;
                break;
            case 7 : 
                //  7	FIN_ETAPA
                _showRechazoInmediato = false;
                break;
            case 8 : 
                //   8	RESUMEN
                _showRechazoInmediato = false;
                break;
            case 9 : 
                //  9	MOTIVO_FORMA
                _showRechazoInmediato = false;
                break;
            case 10 : 
                //  10	CHECKLIST_2
                _showRechazoInmediato = false;
                break; 
            default:
                console.log('por default');
        }

        this.setState(prevState => ({
            nuevaPregunta:{
              ...prevState.nuevaPregunta,
              [name]: value, 
              showRechazoInmediato : _showRechazoInmediato,
              rechazoInmediato : '',
            }
        }));

    }

    /**
     * Maneja el onchange del SELECT de tipo de pantalla 
     * @param {*} e 
     * @param {*} param1 
     */
     _onChangeSelectTipoPantalla(e, { name, value }) {
        let METHODNAME = '_onChangeSelectTipoPantalla - ';
        console.log(METHODNAME + 'name = ' + name + '; value = ' + value + '; id = ' + e.target.id );
        
        /*
         _onChangeSelect(e, { name, value }) 
        this.setState({
            [name]: value
        });
        */

        //aqui en tro por todos los SELECT, por eso se pierde 
        let _showDiasAsignados = false;

        let lEmemet = null;
        switch( value ){
            case 2 :
                lEmemet = [1,2,3,4,5,6,9];
                this.habilitarElementos( lEmemet );
                break;
            case 5 :
                lEmemet = [7];
                this.habilitarElementos( lEmemet );
                break;
            case 6 :
                lEmemet = [2];
                this.habilitarElementos( lEmemet );
                break;
            case 8 :
                lEmemet = [1];
                this.habilitarElementos( lEmemet );
                break;
            case 9 :
                lEmemet = [4];
                this.habilitarElementos( lEmemet );
                break;
            case 10 :
                lEmemet = [3,5];
                this.habilitarElementos( lEmemet );
                _showDiasAsignados = true ; 
                break;
            case 11 :
                lEmemet = [10];
                this.habilitarElementos( lEmemet );
                _showDiasAsignados = true ; 
                break;
            default : 
                lEmemet = [1,2,3,4,5,6,7,9,10];
                this.habilitarElementos( lEmemet );
        }
                 
        this.setState(prevState => ({
            nuevaPregunta:{
              ...prevState.nuevaPregunta,
              [name]: value , 
              showDiasAsignados : _showDiasAsignados,
              datoExtra : '',
            }
        }));

    }

    _handlerChangeTextFunction( e ){
        let valor = e.target.value;
        let name = e.target.name;
        //console.log(METHODNAME + 'name = ' + name + ', value='+ valor );
        /*this.setState({
            [name]: valor
        });*/
        this.setState(prevState => ({
            nuevaPregunta:{
              ...prevState.nuevaPregunta,
              [name]: valor
            }
        }));

    }

    async cargarListaDePreguntasPaginado( paginaActiva ){
        let METHODNAME = 'cargarListaDePreguntasPaginado - ';
        console.log(METHODNAME + 'INI');
 
        let url = server+`/preguntas`;
        
        let _rows = 10;
        let _begin = 0 ;
        let _end = _rows - 1;

        if( paginaActiva > 1 ){
            _begin = paginaActiva * _rows ;
            _end = _rows - 1; 
        }

        let dataForm = null;
        dataForm = {
            pagina : paginaActiva-1,
            filas : _rows,
            valor : this.state.txtBuscarPregunta
        }

        console.log(METHODNAME + 'data = ' + JSON.stringify(dataForm) );
        console.log(METHODNAME + 'txtBuscarPregunta = ' + this.state.txtBuscarPregunta );

        fetch( 
            url , {
            method: 'POST',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            },
            body:JSON.stringify(dataForm)
        })
        .then(res => res.json())
        .then( (result) => {
                console.log(METHODNAME + 'RESULTADO DE LISTA DE PREGUNTAS');
                
                this.setState({
                    isLoaded: true,
                    dimmerEliminarPregunta : false,
                    listaPreguntas: result.listaPreguntas,
                    totalRows: result.cantidadRegistros,
                    activePage : paginaActiva, 
                    totalPages: result.totalPaginas,
                    begin: _begin,
                    end: _end,
                    txtBuscarPregunta : ''
                });

            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )
        console.log(METHODNAME + 'FIN');
    }

    async cargarListasModalPregunta(){
        let METHODNAME = 'cargarListasModalPregunta - ';
        console.log(METHODNAME + 'INI');

        let url = `${server}/preguntas/nueva/`;
        
        const response  = await fetch( url , {
            method: 'GET',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            }
        });
        const json = await response.json();

        return json;
    }

    editarPregunta( idPregunta ){
        let METHODNAME = 'editarPregunta - '; 

        this.setState({
            showModalEdit : false ,
            nuevaPregunta : _preguntaEmpty,
            error2 : '',
            dimmerEliminarPregunta : true 
        });

        let url = server+`/preguntas/${idPregunta}` ;

        fetch( 
            url , {
            method: 'GET',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            } 
        })
        .then(res => res.json())
        .then(
            
            (result) => {

                if( result.resultado === 'true' ){
                     
                    //replicado lo que dice this.cargarListasModalPregunta(); 
                    let _optionsTipoPantalla = [];
                    let _optionsTipoPregunta = [];
                    let _optionsEtapa = [];
        
                    let llenarLista = false; 
                    if( ListaFullTipoPreguntas.length === 0 ){
                        llenarLista = true;
                    }

                    result.listaTipoPregunta.forEach(function(obj) { 
                        if( llenarLista ){
                            ListaFullTipoPreguntas.push( { key: obj.idTipoPregunta , text:  obj.nombre , value: obj.idTipoPregunta } );
                        }
                        _optionsTipoPregunta.push( { key: obj.idTipoPregunta , text:  obj.nombre , value: obj.idTipoPregunta } );
                    });
                    result.listaTipoPantalla.forEach(function(obj) {
                        _optionsTipoPantalla.push( { key: obj.tipoPantallaId , text: obj.nombre , value: obj.tipoPantallaId } );
                    }); 
                    result.listaEtapa.forEach(function(obj) {
                        _optionsEtapa.push( { key: obj.idEtapa , text: obj.etapa , value: obj.idEtapa } );
                    });
        
                    this.setState({

                        dimmerEliminarPregunta : false,
                        optionsTipoPantalla : _optionsTipoPantalla,
                        optionsTipoPregunta : _optionsTipoPregunta,
                        optionsEtapa : _optionsEtapa,
        
                        showModalEdit : true ,
                        nuevaPregunta : {

                            idPregunta : result.pregunta.idPregunta,
                            nombrePregunta : result.pregunta.nombrePregunta,
                            explicacionPregunta : result.pregunta.explicacionPregunta,
                            datoExtra : result.pregunta.datoExtra,
                            posicion : result.pregunta.posicion,
                            flujoSegunPregunta : result.pregunta.flujoSegunPregunta,
                            rechazoInmediato : result.pregunta.rechazoInmediato,
                            validarProyeccion : result.pregunta.validarProyeccion,
                            nota : result.pregunta.nota,
                            saltar : result.pregunta.saltar,
                            respuesta : result.pregunta.respuesta,
                            motivoAlternativaId : result.pregunta.motivoAlternativaId,

                            idEtapa : result.pregunta.etapa ? result.pregunta.etapa.idEtapa : null , 
                            idTipoPregunta : result.pregunta.tipoPregunta ? result.pregunta.tipoPregunta.idTipoPregunta : null ,
                            tipoPantallaId : result.pregunta.tipoPantalla ? result.pregunta.tipoPantalla.tipoPantallaId : null ,
                                                                                    
                            estado : result.pregunta.estado,
                            usuarioCreacion : result.pregunta.usuarioCreacion,
                            usuarioModificacion : result.pregunta.usuarioModificacion,
                            fechaCreacion : result.pregunta.fechaCreacion,
                            fechaModificacion : result.pregunta.fechaModificacion,
                        } 

                    });

                }else{
                    console.error(METHODNAME + 'RESULTADO con error : ' + JSON.stringify(result.error) );
                    this.setState({
                        showModalEdit : false ,
                        nuevaPregunta : _preguntaEmpty,
                        error2 : result.error
                    });
                }
                    
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error2 : error ,
                    error
                });
            }
        ) 

    }

    nuevaPregunta(){
        
        this.setState({
            dimmerEliminarPregunta : true 
        });

        this.cargarListasModalPregunta().then( listas => { 
            
            let _optionsTipoPantalla = [];
            let _optionsTipoPregunta = [];
            let _optionsEtapa = [];

            let llenarLista = false; 
            if( ListaFullTipoPreguntas.length === 0 ){
                llenarLista = true;
            } 
            
            listas.listaTipoPregunta.forEach(function(obj) {
                if( llenarLista ){
                    ListaFullTipoPreguntas.push( { key: obj.idTipoPregunta , text:  obj.nombre , value: obj.idTipoPregunta } );
                }
                _optionsTipoPregunta.push( { key: obj.idTipoPregunta , text:  obj.nombre , value: obj.idTipoPregunta } );
            });
            listas.listaTipoPantalla.forEach(function(obj) {
                _optionsTipoPantalla.push( { key: obj.tipoPantallaId , text: obj.nombre , value: obj.tipoPantallaId } );
            }); 
            listas.listaEtapa.forEach(function(obj) {
                _optionsEtapa.push( { key: obj.idEtapa , text: obj.etapa , value: obj.idEtapa } );
            });

            this.setState({

                optionsTipoPantalla : _optionsTipoPantalla,
                optionsTipoPregunta : _optionsTipoPregunta,
                optionsEtapa : _optionsEtapa,

                nuevaPregunta : _preguntaEmpty,
                showModalEdit:true
            });

            //this.state.nuevaPregunta.showDiasAsignados
            
        });

    }

    guardarPregunta(){
        let METHODNAME = 'guardarPregunta - '; 

        let url = server+`/preguntas/` ;

        let dataForm = {
            authUsername : localStorage.getItem('usuario'), 
            preguntaActual : {

                idPregunta : this.state.nuevaPregunta.idPregunta,
                nombrePregunta : this.state.nuevaPregunta.nombrePregunta,
                explicacionPregunta : this.state.nuevaPregunta.explicacionPregunta,
                datoExtra : this.state.nuevaPregunta.datoExtra,
                posicion : this.state.nuevaPregunta.posicion,
                flujoSegunPregunta : this.state.nuevaPregunta.flujoSegunPregunta,
                rechazoInmediato : this.state.nuevaPregunta.rechazoInmediato,
                validarProyeccion : this.state.nuevaPregunta.validarProyeccion,
                nota : this.state.nuevaPregunta.nota,
                saltar : this.state.nuevaPregunta.saltar,
                respuesta : this.state.nuevaPregunta.respuesta,
                motivoAlternativaId : this.state.nuevaPregunta.motivoAlternativaId,
                
                etapa : {
                    idEtapa : this.state.nuevaPregunta.idEtapa
                },
                tipoPregunta : {
                    idTipoPregunta : this.state.nuevaPregunta.idTipoPregunta,
                },
                tipoPantalla : {
                    tipoPantallaId : this.state.nuevaPregunta.tipoPantallaId,
                },               

                estado : this.state.nuevaPregunta.estado, 
                usuarioCreacion : this.state.nuevaPregunta.usuarioCreacion, 
                usuarioModificacion : this.state.nuevaPregunta.usuarioModificacion, 
                fechaCreacion : this.state.nuevaPregunta.fechaCreacion, 
                fechaModificacion : this.state.nuevaPregunta.fechaModificacion
            }
        }

        fetch(
            url , {
            method: 'POST',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            } ,
            body:JSON.stringify(dataForm)
          })
          .then(res => res.json())
          .then(
            
            (result) => {

                if( result.resultado === 'true'){

                    this.setState({
                        isLoaded: true, 
                        showModalEdit:false,
                        nuevaPregunta : _preguntaEmpty,
                        dimmerEliminarPregunta : false ,
                    });
        
                    this.cargarListaDePreguntasPaginado( 1 );
                }else{
                    console.error(METHODNAME + 'Error al registrar: '  + result.error);
                }
  
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )

    }

    preEliminarPregunta( preguntaId ){
        this.setState({
            confirmEliminarPreguntaOpen: true , 
            preguntaIdDelete : preguntaId ,
            dimmerEliminarPregunta :  false 
        });
    }

    handleChangeBoolean( name , mostrar ){
        this.setState({
            [name]: mostrar
        });
    }

    async eliminarPregunta(){
        let METHODNAME = 'eliminarPregunta - ';
        console.log( METHODNAME + 'INI ');
   
        if( this.state.preguntaIdDelete === null){
            console.log('No hay ID de pregunta para eliminar');
            return;
        }

        this.setState({ 
            dimmerEliminarPregunta : true  
        });

        let url =  `${server}/preguntas/${this.state.preguntaIdDelete}/`;
        let dataForm = {
            authUsername : localStorage.getItem('usuario'),
        }
        const json = await fetch( url , {
            method: 'DELETE',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            } ,
            body:JSON.stringify(dataForm)
        }).then((result) => {
           
            result.json().then((resp) => {

                if( resp.resultado === 'true' ){
                    
                    this.setState({
                        confirmEliminarPreguntaOpen: false , 
                        preguntaIdDelete : null ,
                        dimmerEliminarPregunta :  false  
                    });

                    this.cargarListaDePreguntasPaginado( 1 );

                }else{
                    console.warn(METHODNAME +  'No se pudo eliminar. Error : ' + JSON.stringify(resp.error) );

                    this.setState({ 
                        dimmerEliminarPregunta : false  
                    });

                }

            }).catch((error) => { 
                console.error(METHODNAME +  'Error al procesar respuesta: ' + error)
                this.setState({ 
                    dimmerEliminarPregunta : false  
                });
            });

        }).catch((error) => { 
            console.error(METHODNAME +  'Server Error: ' + error)
        });
        return json;
    }    

    setShowModalEdit( mostrar ){
        this.setState({
            showModalEdit: mostrar , 
            dimmerEliminarPregunta : false
        });
    }

    handleDismiss = ( nombre ) => {

        this.setState({ [nombre]: null })

        setTimeout(() => {
            this.setState({ visible: true })
        }, 2000)
    }

    handleChangeSearch = (e, { name, value }) => {
        this.setState({ [name]: value })
    }

    handleSubmitSearch = () => { 
        this.cargarListaDePreguntasPaginado( 1 ); 
    }

    render() {

        const { error, isLoaded, listaPreguntas , activePage , totalPages , txtBuscarPregunta } = this.state;

        if (error) {
            //return <div>Error: {error.message}</div>;
            return (<Message 
                  header='Ha ocurrido un error:'
                  content={error.message}
                />)
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {

            return(
                <div>
            <Container>

                <Header as='h2' content='Lista de Preguntas' style={style.h1} textAlign='center' />

                <Form key='kf001' onSubmit={this.handleSubmitSearch} >
                    <FormGroup key='kfg001'>
                        <Input
                            key='kip001'
                            placeholder='Filtrar por columna Explicaion' 
                            name='txtBuscarPregunta'
                            value={txtBuscarPregunta}
                            onChange={this.handleChangeSearch}
                        />
                        <Button key='kbt001' color='blue' size='tiny'>
                            <Icon name="search" />
                            Buscar
                        </Button>
                    </FormGroup>
                </Form>

                <div>
 
                    <Button onClick={ () => this.nuevaPregunta()}
                            color='green' size='tiny' >
                        <Icon name="save" />
                        Agregar nueva pregunta</Button>
                 
                </div>
            
                <Table celled>
                    <Table.Header>
                        <Table.Row key='head0001'>
                            <Table.HeaderCell>Número</Table.HeaderCell> 
                            <Table.HeaderCell>Titulo</Table.HeaderCell>
                            <Table.HeaderCell>Explicacion</Table.HeaderCell>
                            <Table.HeaderCell>Tipo Pregunta</Table.HeaderCell>
                            <Table.HeaderCell>Tipo Pantalla</Table.HeaderCell>
                            <Table.HeaderCell>Acciones</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
            
                    <Table.Body>
                        
                        { listaPreguntas && listaPreguntas.map(pregunta => (
                            <Table.Row key={pregunta.idPregunta}>
                                <Table.Cell> <Label ribbon>{pregunta.posicion}</Label> </Table.Cell> 
                                <Table.Cell>{pregunta.nombrePregunta}</Table.Cell>
                                <Table.Cell>
                                    <div dangerouslySetInnerHTML={{__html: pregunta.explicacionPregunta}} /> 
                                </Table.Cell>
                                <Table.Cell>{pregunta.tipoPregunta ? pregunta.tipoPregunta.nombre : '--'}</Table.Cell>
                                <Table.Cell>{pregunta.tipoPantalla ? pregunta.tipoPantalla.nombre : '--'}</Table.Cell>
                                <Table.Cell>

                                    <Link to={`/pregunta/${pregunta.idPregunta}/alternativas`}> 
                                        <Button color='green' animated="vertical" size='mini' title='Ver Alternativas' >
                                            <Button.Content visible><Icon name="tasks"/></Button.Content>
                                            <Button.Content hidden>
                                            Alternativas
                                            </Button.Content>
                                        </Button>
                                    </Link>

                                    <Button color='blue' animated="vertical" size='mini' 
                                        onClick={ () => this.editarPregunta(pregunta.idPregunta)}  >
                                        <Button.Content visible><Icon name="edit outline"/></Button.Content>
                                        <Button.Content hidden>
                                            Editar
                                        </Button.Content>
                                    </Button>

                                    { pregunta.tipoPregunta.puedeGenerarResultado &&
                                        <Link to={`/pregunta/${pregunta.idPregunta}/resultados`}> 
                                            <Button color='orange' animated="vertical" title='Resultado' size='mini'>
                                                <Button.Content visible><Icon name="sitemap"/></Button.Content>
                                                <Button.Content hidden>
                                                Resultados
                                                </Button.Content>
                                            </Button>
                                        </Link>
                                    }

                                    <Button color='red' animated="vertical" size='mini'
                                            onClick={ () => this.preEliminarPregunta(pregunta.idPregunta)}  >
                                        <Button.Content visible><Icon name="trash alternate outline"/></Button.Content>
                                        <Button.Content hidden>
                                            Eliminar
                                        </Button.Content>
                                    </Button>

                                </Table.Cell>
                            </Table.Row>
                        ))}

                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan='6' textAlign='center'>
                                <Pagination key='pag0001'
                                    activePage={activePage} 
                                    onPageChange={this.onChange}
                                    totalPages={totalPages} />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
            
                </Table>

                <Confirm
                    open={this.state.confirmEliminarPreguntaOpen}
                    header='Eliminar Registro'
                    content='¿Está seguro que desea eliminar el registro seleccionado?'
                    onCancel={ () => this.handleChangeBoolean('confirmEliminarPreguntaOpen', false )} 
                    onConfirm={this.eliminarPregunta}
                />

                <Dimmer active={this.state.dimmerEliminarPregunta} inverted >
                    <Loader>Loading</Loader>
                </Dimmer>

            </Container>
            
            <Modal
                as={Form} 
                onSubmit={this.guardarPregunta} 
                closeIcon
                closeOnEscape={false}
                onClose={() => this.setShowModalEdit(false)} 
                open={this.state.showModalEdit} 
            >
            <Modal.Header>Información de Pregunta</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <Grid columns={4}>
                        <Grid.Row>
                            <Grid.Column width={3}>
                                Posición de la Pregunta:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Indica que posición ocupará esta nueva pregunta. Al registrar una nueva, las preguntas existentes subirán una posicón para dar espacio a esta nueva.'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column width={5}>
                            <Input type='number' placeholder='posición'
                                    errorMessages={['Se requiere completar este campo' , 'Debe ser mayor a 0' , 'Solo se aceptan números' ]} 
                                    validators={['required' , 'minNumber:1', 'matchRegexp:^[1-9][0-9]{0,2}$' ]} 
                                    name='posicion' 
                                    value={this.state.nuevaPregunta.posicion} 
                                    onChange = {this._handlerChangeTextFunction}
                                    disabled={this.state.nuevaPregunta.idPregunta} />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={3}>
                                Tipo de Pantalla:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Indica la forma en la que el sistema procesa y muestra la pregunta en la pantalla'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column width={5}>
                                <Dropdown    
                                    id='tipoPantallaId'
                                    name='tipoPantallaId'
                                    value={this.state.nuevaPregunta.tipoPantallaId} 
                                    placeholder='-SELECCIONAR-'
                                    options={this.state.optionsTipoPantalla}
                                    onChange={this._onChangeSelectTipoPantalla}  
                                    errorMessages={['Debe seleccionar un valor']} 
                                    validators={['required']}
                                    />
                            </Grid.Column>
                            <Grid.Column width={3}>
                                Tipo de Pregunta:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Indica la forma en que el sistema interpreta a la pregunta'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column width={5}>
                                <Dropdown 
                                    id='idTipoPregunta'
                                    name='idTipoPregunta'
                                    value={this.state.nuevaPregunta.idTipoPregunta} 
                                    placeholder='-SELECCIONAR-'
                                    options={this.state.optionsTipoPregunta}
                                    onChange={this._onChangeSelectTipoPregunta}  
                                    errorMessages={['Debe seleccionar un valor']} 
                                    validators={['required']}
                                    />
                            </Grid.Column>
                            
                        </Grid.Row> 
                        <Grid.Row>
                            <Grid.Column width={3}>
                                Etapa:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Etapa a la que corresponde esta pregunta'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column width={5}>    
                                <Dropdown    
                                    id='idEtapa'
                                    name='idEtapa'
                                    value={this.state.nuevaPregunta.idEtapa} 
                                    placeholder='-SELECCIONAR-'
                                    options={this.state.optionsEtapa}
                                    onChange={this._onChangeSelect}  
                                    errorMessages={['Debe seleccionar una etapa']} 
                                    validators={['required']}
                                    />
                            </Grid.Column> 
                        </Grid.Row> 
                        { this.state.nuevaPregunta.showRechazoInmediato &&
                            <Grid.Row>
                                <Grid.Column width={3}>
                                Rechazo Inmediadto:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Explicacion de como usar la columna de Rechazo Inmediato'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column>
                                <Input placeholder='valor numerico' 
                                    name='rechazoInmediato' 
                                    value={this.state.nuevaPregunta.rechazoInmediato} 
                                    onChange = {this._handlerChangeTextFunction}/>
                            </Grid.Column>
                            </Grid.Row>
                            }
                        { this.state.nuevaPregunta.showDiasAsignados &&
                        <Grid.Row>
                            <Grid.Column width={3}>
                                Días asignados:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Solo para Tipo de pantalla Plazo Fecha 2 o Fecha Compleja. Cantidad de días que se le asigna por default a la pregunta'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column>
                                <Input placeholder='Días asignados por default' 
                                    name='datoExtra' 
                                    value={this.state.nuevaPregunta.datoExtra} 
                                    onChange = {this._handlerChangeTextFunction}/>
                            </Grid.Column>
                        </Grid.Row>
                        }
                        <Grid.Row>
                            <Grid.Column width={3}>
                                Titulo:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Titulo corto de la pregunta. Se muestra como primera fila en la pantalla de cada pregunta.'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column width={13}>
                                <Input fluid placeholder='Título de la pregunta'
                                    errorMessages={['Se requiere completar este campo']} 
                                    validators={['required']} 
                                    name='nombrePregunta' 
                                    value={this.state.nuevaPregunta.nombrePregunta} 
                                    onChange = {this._handlerChangeTextFunction}/>
                            </Grid.Column>  
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={3}>
                                Explicacion:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Texto completo de la pregunta'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column width={13}>
                                <Input fluid placeholder='Explicacion' 
                                    errorMessages={['Se requiere completar este campo']} 
                                    validators={['required']} 
                                    name='explicacionPregunta' 
                                    value={this.state.nuevaPregunta.explicacionPregunta} 
                                    onChange = {this._handlerChangeTextFunction}/>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={3}>
                                Nota:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Mensaje adicional a mostrar en la pantalla'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column width={13}>
                                <Form >
                                <TextArea fluid 
                                    placeholder='Notas adicionales'
                                    name='nota' 
                                    rows='4'
                                    value={this.state.nuevaPregunta.nota} 
                                    onChange = {this._handlerChangeTextFunction} />
                                </Form>
                            </Grid.Column>
                        </Grid.Row> 
                        <Grid.Row>
                            <Grid.Column width={3}>
                                Flujo segun pregunta:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Este dato sirve para indicar que la siguiente pregunta a mostrar depende del numero de pregunta que indiquemos en este campo'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column width={5}>
                                <Input placeholder='Pregunta de la cual se depende' 
                                    name='flujoSegunPregunta' 
                                    value={this.state.nuevaPregunta.flujoSegunPregunta} 
                                    onChange = {this._handlerChangeTextFunction}/>
                            </Grid.Column> 
                            <Grid.Column width={4}> 
                                Saltar:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Indica a que pregunta se debe ir luego de procesar el resultado de esta pregunta y el resultado sea satisfactorio.'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column>
                            <Input placeholder='Numero de pregunta' 
                                    name='saltar' 
                                    value={this.state.nuevaPregunta.saltar} 
                                    onChange = {this._handlerChangeTextFunction}/>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Description>

            </Modal.Content>
            <Modal.Actions>
                <Button color='red' onClick={() => this.setShowModalEdit(false)}>
                    Cancelar
                </Button>
                <Button
                    type='submit'
                    content="Regsitrar"
                    labelPosition='right'
                    icon='checkmark'
                    positive
                />
            </Modal.Actions>
            </Modal>
            </div>
            );

        }
    }
}